import { ArrowRight } from 'lucide-react';
import { FC } from 'react';
import StepCard from './StepCard';

const HowItWorks: FC = () => {
  const steps = [
    {
      number: 1,
      title: 'Choose Your Template',
      description: 'Select from professionally designed templates.',
      image: '/api/placeholder/300/200',
      delay: '0.1s',
    },
    {
      number: 2,
      title: 'Customize & Optimize',
      description: 'Edit with AI and improve your ATS score.',
      image: '/api/placeholder/300/200',
      delay: '0.3s',
    },
    {
      number: 3,
      title: 'Download & Apply',
      description: 'Export as PDF and start applying.',
      image: '/api/placeholder/300/200',
      delay: '0.5s',
    },
  ];

  return (
    <section id='how-it-works' className='py-20 bg-secondary/5 relative overflow-hidden'>
      <div className='container mx-auto px-4'>
        <div className='text-center max-w-2xl mx-auto mb-16'>
          <div className='inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-md text-sm font-medium mb-4'>
            <span>Simple Process</span>
          </div>
          <h2 className='text-3xl lg:text-4xl font-bold mb-4 text-foreground'>
            From Demo to Done in Minutes
          </h2>
          <p className='text-lg text-muted-foreground'>
            Three simple steps to your professional resume.
          </p>
        </div>
        <div className='relative'>
          <div className='hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-primary/20 -translate-y-1/2 z-0'></div>
          <div className='grid lg:grid-cols-3 gap-12 relative z-10'>
            {steps.map((step) => (
              <StepCard
                key={step.number}
                number={step.number}
                title={step.title}
                description={step.description}
                image={step.image}
                delay={step.delay}
              />
            ))}
          </div>
        </div>
        <div
          className='mt-16 text-center animate-fadeInUp'
          style={{ animationDelay: '0.7s' }}>
          <button className='bg-primary text-primary-foreground rounded-md px-8 py-4 text-lg font-medium transition-smooth hover:bg-primary/90 hover:shadow-lg group'>
            <span className='flex items-center justify-center'>
              Start Your Free Trial
              <ArrowRight
                size={18}
                className='ml-2 transition-transform duration-300 group-hover:translate-x-1'
              />
            </span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
